import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import {
  SupportAccessGrant,
  SupportAccessGrantListResponse,
  SupportAccessRequestCreateRequest,
  SupportAccessSessionStartResponse,
} from '@chiroup/core/types/SupportAccess.type';

const supportAccessService = () => {
  const listGrants = async (
    clinicId: number,
    excludeExpired: boolean
  ): Promise<SupportAccessGrantListResponse> => {
    return ChiroUpAPI.get('api', `/clinic/${clinicId}/support-access/grants`, {
      queryParams: { excludeExpired: String(excludeExpired) },
    });
  };

  const startSession = async (
    clinicId: number,
    grantId: string
  ): Promise<SupportAccessSessionStartResponse> => {
    return ChiroUpAPI.post('api', `/clinic/${clinicId}/support-access/grants/${grantId}/sessions`, {
      body: {},
    });
  };

  const requestAccess = async (
    clinicId: number,
    body: SupportAccessRequestCreateRequest
  ): Promise<SupportAccessGrant> => {
    return ChiroUpAPI.post('api', `/clinic/${clinicId}/support-access/requests`, { body });
  };

  return {
    listGrants,
    startSession,
    requestAccess,
  };
};

export default supportAccessService();
